export default __webpack_public_path__ + "static/careers-team-link-block2-icon.url-8acea8a04c02ad6be87ee9deddb200b8.svg";